import React from 'react'
export default function ILetterIcon() {
    return (
        <svg  viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99563 6C9.58188 6 9.22917 5.85271 8.9375 5.55812C8.64583 5.26354 8.5 4.90937 8.5 4.49562C8.5 4.08187 8.64729 3.72917 8.94187 3.4375C9.23646 3.14583 9.59062 3 10.0044 3C10.4181 3 10.7708 3.14729 11.0625 3.44188C11.3542 3.73646 11.5 4.09063 11.5 4.50438C11.5 4.91813 11.3527 5.27083 11.0581 5.5625C10.7635 5.85417 10.4094 6 9.99563 6ZM8.75 17V8H11.25V17H8.75Z" fill="black"/>
        </svg>
    )
}


